import { createStore } from "vuex";
import projectsModule from "./projects/index.js";
import employeeModule from "./employees/index.js";
import taskModule from "./task/index.js";
import authModule from "./auth/index.js";

export default createStore({
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    projects: projectsModule,
    employees: employeeModule,
    task: taskModule,
    auth: authModule,
  },
});
